import { render, staticRenderFns } from "./rollStatistics.vue?vue&type=template&id=8d4fe704"
import script from "./rollStatistics.vue?vue&type=script&lang=js"
export * from "./rollStatistics.vue?vue&type=script&lang=js"
import style0 from "./rollStatistics.vue?vue&type=style&index=0&id=8d4fe704&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports